import { IDataPage } from '../interfaces/common';
import { IProduct } from '../interfaces/product';
import { FilterOptionEnum, FilterType } from '../react-pages/Catalog/types';
import { homePageDealerCodes } from '../react-pages/Product/mock';
import { getConfig } from '../utils/sessionStorageUtils';
import axios from './axios';
import { ChronoResponse } from './chrono-response';

export const getHomeProducts = async (query?: string) => {
  let url = '';
  homePageDealerCodes?.forEach((item) => {
    url = url.concat(
      `filter[column]=dealerProductCode&filter[value]=${item
        ?.replaceAll('&', '%26')
        ?.replaceAll('/', '%2F')}&filter[option]=${FilterOptionEnum.IsEqualTo}&`
    );
  });
  url = url.concat(`&${query}`);
  try {
    const result = await axios.get(`/Products/catalog/5/0?${url}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getProducts = async (size: number = 5, index: number = 0) => {
  try {
    const result = await axios.get(`/Products/catalog/${size}/${index}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getNewArrivals = async (size: number = 12, index: number = 0) => {
  let url = 'sorting[column]=createdAt&sorting[order]=2';
  try {
    const result = await axios.get(`/Products/catalog/${size}/${index}?${url}`, getConfig());
    return result?.data;
  } catch (e) {
    console.error(e);
  }
};

export const getFilteredProducts = async (url: string) => {
  try {
    const result = await axios.get<IDataPage<IProduct[]>>(`/Products/catalog/${url}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getFilterKeys = async () => {
  try {
    const result = await axios.get<ChronoResponse<FilterType[]> | undefined>(`/Filters/keys`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getAlsoLikedProducts = async (id: string) => {
  try {
    const result = await axios.get(`/RecommendedProducts/${id}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getProduct = async (url: string) => {
  try {
    const result = await axios.get(url, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getProductByDealerCode = async (
  productDealerCode: string
): Promise<ChronoResponse<IProduct> | undefined> => {
  try {
    const result = await axios.get(`Products/byDealerCode?dealerProductCode=${productDealerCode}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getProductFilters = async (query: string) => {
  try {
    const result = await axios.get(`/Filters/products?${query || ''}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getCollectionsProductFilters = async (query: string, groupId?: string) => {
  try {
    const result = await axios.get(`/Filters/products?${query || `${groupId || ''}`}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getSuggestions = async (text: string, size: number = 12, index: number = 0) => {
  try {
    const result = await axios.get(
      `/Search/${size}/${index}?text=${text?.replaceAll('/', '%2F')?.replaceAll('&', '%26')}`,
      getConfig()
    );
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const createNewProduct = async (newProduct: any) => {
  try {
    const result = await axios.post(`/Products/create-product`, newProduct, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const editProduct = async (product: IProduct) => {
  try {
    const result = await axios.put(`/Products/${product?.id}`, product, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const deleteProduct = async (productId: string) => {
  try {
    const result = await axios.delete(`/Products/${productId}`, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const togglePublished = async (product: IProduct) => {
  try {
    const result = await axios.put(`/Products/publish/${product?.id}`, undefined, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const exportProducts = async (count?: number) => {
  try {
    const result = await axios.get(`/Export/export-products/json`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
